import lodashGet from "lodash/get";
import lodashHas from "lodash/has";

import { ENDPOINT_DIGESTS } from "@/common/constants/api";
import { httpGet, httpPost } from "@/services/api.service";

export { _getDigests as getDigests };
export { _enableDigest as enableDigest };
export { _disableDigest as disableDigest };

/// DIGESTS
const _getDigests = async (params) => {
  try {
    const RESULT = await httpGet({
      url: `${ENDPOINT_DIGESTS}`,
      noCache: true,
    });
    const { data } = JSON.parse(RESULT);

    if (data) {
      return data;
    }
    return false;
  } catch (error) {
    console.error("Unable to get digests: ", JSON.stringify(error));
    return false;
  }
};

const _toggleDigest = async (params) => {
  if (!params || !params.type || !params.mode) {
    console.error(`Unable to ${params.mode} digest`);
    return false;
  }

  try {
    if (params.mode && params.type) {
      let res = await httpPost({
        url: `${ENDPOINT_DIGESTS}/${params.type}/${params.mode}`,
      });
      res = JSON.parse(res);

      if (res && res.data) {
        return res.data;
      }
    }
  } catch (error) {
    console.error("Unable to enable digest: ", JSON.stringify(error));
    if (lodashHas(error, "data.message")) {
      throw new Error(lodashGet(error, "data.message"));
    }
    return false;
  }
};

const _enableDigest = async (params) => {
  params.mode = "enable";
  return await _toggleDigest(params);
};

const _disableDigest = async (params) => {
  params.mode = "disable";
  return await _toggleDigest(params);
};
